/* wtf-sticky-hold.js
 *
 * WTF 2026-10-12 (CRO fix 2; judge-qa finding, cancer-free RESULTS.md: "When the date box or Add is scrolled to the very
 * bottom edge, the fixed sticky Add bar sits over it").
 *
 * The sticky Add bar (assets/wtf-ff-pdp.js) hides only while the real Add button is clear of the bottom 66 px of the screen.
 * A required custom field (the Cancer-Free date box, the House Divided team fields) did not count at all, so the bar could
 * sit on top of a box the shopper was about to type in.
 *
 * This file holds the bar down while ANY of these touches the screen, even by one pixel:
 *   - the real Add to cart button of the product form,
 *   - a personalization box ([data-wtf-teams]), or a required properties[...] field inside the product info column.
 * It only adds or removes one class (wtf-ff-sticky-atc--hold) on the bar. The CSS for that class is in assets/wtf-batch-b.css.
 * It does not touch the cart, the form, the size sheet, or wtf-ff-pdp.js. No class on the bar = no change to the old behaviour.
 */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;

  var HOLD = 'wtf-ff-sticky-atc--hold';
  var SELECTOR =
    '[data-wtf-teams], .product__info-wrapper [name^="properties["][required], form[data-type="add-to-cart-form"] button[name="add"]';
  var state = []; /* [{ el, on }] */
  var io = null;
  var pending = false;

  function bar() {
    return document.querySelector('.wtf-ff-sticky-atc');
  }

  function apply() {
    var b = bar();
    if (!b) return;
    var hold = state.some(function (s) {
      return s.on;
    });
    b.classList.toggle(HOLD, hold);
  }

  function scan() {
    pending = false;
    state = state.filter(function (s) {
      if (document.documentElement.contains(s.el)) return true;
      io.unobserve(s.el);
      return false;
    });
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (el) {
      var known = state.some(function (s) {
        return s.el === el;
      });
      if (known) return;
      state.push({ el: el, on: false });
      io.observe(el);
    });
    apply();
  }

  function init() {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          state.forEach(function (s) {
            if (s.el === en.target) s.on = en.isIntersecting;
          });
        });
        apply();
      },
      { threshold: 0 }
    );
    scan();

    /* The theme re-renders the product form on a variant change and swaps the Add button node. Look again. */
    var host = document.querySelector('.product__info-container') || document.querySelector('.product__info-wrapper');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.setTimeout(scan, 60);
      }).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
